import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface MemberCounts {
  total: number;
  washington: number;
  union: number;
}

export const useMemberCount = () => {
  return useQuery({
    queryKey: ["member-count"],
    queryFn: async (): Promise<MemberCounts> => {
      const [washRes, unionRes] = await Promise.all([
        supabase
          .from("members")
          .select("*", { count: "exact", head: true })
          .eq("chapter", "washington")
          .eq("is_hidden", false),
        supabase
          .from("members")
          .select("*", { count: "exact", head: true })
          .eq("chapter", "union")
          .eq("is_hidden", false),
      ]);

      if (washRes.error) console.error("Error fetching washington count:", washRes.error);
      if (unionRes.error) console.error("Error fetching union count:", unionRes.error);

      const washington = washRes.count ?? 0;
      const union = unionRes.count ?? 0;

      return {
        total: washington + union,
        washington,
        union,
      };
    },
  });
};
